angular.module('leave')
    .component('leaveTypeMultiselect', {
        bindings: {
            modelType: '<',
            required: "=",
            onChange: '&?',
        },
        require: {
            ngModelCtrl: 'ngModel'
        },
        template: `
            <ol class="nya-bs-select btn-sm" ng-model="$ctrl.selected" ng-change="$ctrl.onSelectionChanged()" actions-box="true" data-selected-text-format="count>2" multiple size="10" title="-- rodzaj --" live-search="true" ng-model-options="{ updateOn: 'blur' }">
                <li nya-bs-option="option in $ctrl.items group by option.category track by option.id" data-value="option.id" deep-watch="true">
                    <span class="dropdown-header">{{'leave-type.category.' + $group | translate}}</span>
                    <a>
                        <span>{{option.name}}</span>
                        <span class="check-mark"><i class="fa fa-thumb-tack"></i></span>
                    </a>
                </li>
            </ol>
        `,
        controller: function (LeaveType) {
            const ctrl = this;

            ctrl.$onInit = () => {
                LeaveType.autocomplete().$promise.then(items => {
                    ctrl.items = formatAndMap(items)
                })

                ctrl.ngModelCtrl.$render = () => ctrl.selected = ctrl.ngModelCtrl.$viewValue;
                ctrl.ngModelCtrl.$formatters.push(modelValue => modelValue);
                ctrl.ngModelCtrl.$parsers.push(viewValue => ctrl.modelType === "id" ? viewValue.id : viewValue);
            };

            ctrl.onSelectionChanged = () => {
                ctrl.ngModelCtrl.$setViewValue(ctrl.selected);
                ctrl.ngModelCtrl.$validate();
                ctrl.ngModelCtrl.$render();
                console.log("Selected leave types: ", ctrl.selected);
                if (angular.isFunction(ctrl.onChange)) {
                    ctrl.onChange({$type: ctrl.selected});
                }
            };

            function formatAndMap(items) {
                if (!angular.isArray(items)) {
                    return []
                }
                return items
                    .map(item => ({id: item.id, name: item.name, category: item.category}))
                    .sort((a, b) => a.name > b.name ? 1 : -1)
            }
        }
    })
